/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat3_BodyInputs */

const es_l6_feat3_body = /** @type {(inputs: L6_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidad junto al resto de modalidades: una sola casa para cualquier barco de España.`)
};

const gl_l6_feat3_body = /** @type {(inputs: L6_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidade xunto ao resto de modalidades: un só fogar para calquera barco de España.`)
};

const en_l6_feat3_body = /** @type {(inputs: L6_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility alongside our other options: one home for every boat in Spain.`)
};

/**
* | output |
* | --- |
* | "Visibility alongside our other options: one home for every boat in Spain." |
*
* @param {L6_Feat3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat3_body = /** @type {((inputs?: L6_Feat3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat3_body(inputs)
	if (locale === "en") return en_l6_feat3_body(inputs)
	return es_l6_feat3_body(inputs)
});